/**
 * Módulos e cores da plataforma, portados literalmente do protótipo
 * (`prototipo/Mandato360-prototipo-identidade_3.html`, proto:1859 e
 * proto:1866-1867).
 *
 * `home` guarda o caminho React (não a rota curta do protótipo) —
 * é o que a aplicação usa para navegar.
 */

export const MOD_COLORS = {
  eleg: '#F58406',
  gab: '#8B5CF6',
  atend: '#3DDC84',
  analytics: '#3B82F6',
  terr: '#22D3EE',
  com: '#EC4899',
} as const;

export type ChaveModulo = 'eleg' | 'gab';

export interface Modulo {
  n: string;
  sub: string;
  cor: string;
  grupos: string[];
  home: string;
  seg: number;
  /**
   * Palavra exibida no lugar do símbolo, onde o módulo se apresenta.
   *
   * `null` usa o símbolo. Isto mora aqui porque o cartão do Hub e o seletor da
   * barra lateral desenham a mesma coisa: antes, cada um tinha o seu próprio
   * `if (chave === 'eleg')` com a palavra escrita à mão, e quando a marca
   * mudou um deles ficou para trás — o Hub passou a dizer uma coisa e a barra
   * lateral outra, na mesma tela.
   */
  marca: string | null;
}

export const MODULOS: Record<ChaveModulo, Modulo> = {
  eleg: {
    /*
      O módulo se chamava "Eleg". Com a plataforma passando a Eleg360, o nome
      curto virava um "Eleg dentro de Eleg360" no Hub. O rótulo mudou; a CHAVE
      `eleg` NÃO — ela governa o controle de módulo contratado, as rotas e as
      permissões gravadas no banco, e renomeá-la trocaria um problema de
      leitura por um de acesso.
    */
    n: 'Inteligência Eleitoral',
    sub: 'Votações, território e histórico',
    cor: MOD_COLORS.eleg,
    grupos: ['Inteligência Eleitoral', 'OTO · Estratégia'],
    marca: 'Analytics',
    home: '/eleg',
    seg: 0,
  },
  gab: {
    n: 'Gabinete360',
    sub: 'Contatos, demandas, agenda e ações',
    cor: MOD_COLORS.gab,
    grupos: ['Gestão', 'Relacionamento', 'Atendimento', 'Atuação', 'Administração'],
    marca: null,
    home: '/dashboard',
    seg: 4,
  },
};
